import React from 'react';
import './EpicSpinner.scss'

const EpicSpinner = ({noBg}) => (
  <div className={!!noBg ? "epic-spinner-wrapper no-bg" : "epic-spinner-wrapper"}>
    <div className="fulfilling-square-spinner">
      <div className="spinner-inner"></div>
    </div>    
  </div>
);

export default EpicSpinner